import React, { PureComponent } from "react";
import Popup from "./Popup.js";
import Button from "../Button/Button.js";
import Constants from '../Constants.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUnlock } from '@fortawesome/free-solid-svg-icons'
library.add(faUnlock);



class PopupOutOfLevels extends PureComponent {

    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.popup = React.createRef();
    }

    show() {
        this.popup.current.show();
    }
    hide() {
        this.popup.current.hide();
    }

    render() {

        const price = this.props.prices.levels;

        return (
            <Popup
                ref={this.popup}
                showing={false}
            >
                <h1 className="Title">
                    Unlock {Constants.paidLevels} More Levels?
                </h1>
                <div className="Wrapper">
                    <FontAwesomeIcon
                        className="UnlockIcon"
                        icon="unlock"
                    />
                </div>
                <p className="Paragraph">
                    Can't get enough? Don't worry—there are {Constants.paidLevels} more levels waiting for you!
                </p>
                <div
                    style={{
                        display: 'inline-block',
                        boxSizing: 'border-box',
                    }}
                >
                    <Button
                        activeColor={'#fff'}
                        inactiveColor={'#3c40c6'}
                        borderColor={'#3c40c6'}
                        onClick={() => {
                            if (window.store) {
                                window.store.order('levels');
                            }
                            // Hide popup
                            this.popup.current.hide();
                        }}
                    >
                        <FontAwesomeIcon className="ButtonIcon" icon="unlock" />
                        Unlock Now
                    </Button>
                    <div
                        className="Price"
                    >
                        {price && 'for ' + price}
                    </div>
                </div>
            </Popup>
        );
    }
}

export default PopupOutOfLevels;
